import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import StyledSlidePreview from '../previews/StyledSlide'
import Input from '../../form/Input'
import Button from '../../../UniformComponents/Button'

const AddSectionModal = ({ store }) => {
    const { addSectionModalOpen, handleCloseAddSectionModal, addSection, selectSection } = store

    return (
        <Modal
            show={addSectionModalOpen}
            onClose={handleCloseAddSectionModal}
        >
            <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                <Typography type="h3">Add Section</Typography>
            </div>

            <br />

            <hr />

            <br />

            <Typography>Please enter a section name’</Typography>

            <br />

            <Input
                label="Section title"
                onBlur={store.editNewSectionTitle}
                defaultValue={store.newSectionTitle}
            />

            <br />

            <Typography>Choose either a Section Header or Section Summary slide to add to your new section. This new section will be added to the end of your presentation.  You can rename and reorder sections at any time.</Typography>

            <br />

            <div>
                <div className="pp-slide-modal-options-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '80%', justifySelf: 'center' }}>
                    <div className={store.addSectionModal.template === 'sectionHeader' ? ' pp-slide-modal-option-active' : 'pp-slide-modal-option'} onClick={() => selectSection('sectionHeader')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.sectionHeader')}</Typography>
                    </div>

                    <Typography type="b">OR</Typography>

                    <div className={store.addSectionModal.template === 'sectionSummary' ? ' pp-slide-modal-option-active' : 'pp-slide-modal-option'} onClick={() => selectSection('sectionSummary')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.sectionSummary')}</Typography>
                    </div>
                </div>
            </div>

            <br />

            <br />

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <Button
                    label="Cancel"
                    cssClass="regular tertiary"
                    onClick={handleCloseAddSectionModal}
                />

                <Button
                    label="Add Section"
                    cssClass="regular primary"
                    icon="far fa-circle-plus"
                    onClick={addSection}
                    disabled={!store.addSectionModal.title || !store.addSectionModal.template}
                />
            </div>
        </Modal>
    )
}

export default observer(AddSectionModal)
